export default "__VITE_ASSET__73b483e9__"